import React from 'react';
import styled from '@emotion/styled';

import SPACING from '../../styles/emotion/spacing';
import COLORS3 from '../../styles/emotion/colors3';
import MEDIA_QUERY_V2 from '../../styles/emotion/mediaQueryV2';

export type ModuleTileOuterProps = {
  withMobileSpacer?: boolean;
};

export const ModuleTileOuter = styled.div<ModuleTileOuterProps>`
  background-color: ${COLORS3.WHITE_100};
  ${(props) =>
    props.withMobileSpacer
      ? `
    padding: ${SPACING.S16};
  `
      : `
    ${MEDIA_QUERY_V2.EXCLUDE_MOBILE} {
      padding: ${SPACING.S16};
    }
  `}
`;

export type ModuleTileSpacerProps = {
  background: string;
  withMobileSpacer?: boolean;
};

export const ModuleTileSpacer = styled.div<ModuleTileSpacerProps>`
  background: ${({ background }) => background};
  height: 100%;
  ${(props) =>
    props.withMobileSpacer
      ? `
    border-radius: ${SPACING.S16};
  `
      : `
    ${MEDIA_QUERY_V2.EXCLUDE_MOBILE} {
      border-radius: ${SPACING.S16};
    }
  `}
`;

export const ModuleTileInner = styled.div`
  padding: ${SPACING.S32} ${SPACING.S24};
  ${MEDIA_QUERY_V2.TABLET} {
    padding: ${SPACING.LG};
  }
  ${MEDIA_QUERY_V2.DESKTOP} {
    padding: ${SPACING.S24};
  }
  ${MEDIA_QUERY_V2.DESKTOP_XL} {
    padding: ${SPACING.S24};
  }
  ${MEDIA_QUERY_V2.DESKTOP_MASSIVE} {
    padding: 48px; // TODO: Add as var
  }
`;

export type ModuleTileProps = {
  className?: string;
  background?: string;
  withMobileSpacer?: boolean;
};

export const ModuleTile: React.FC<ModuleTileProps> = ({
  background = COLORS3.WHITE_100,
  children,
  className,
  withMobileSpacer = false,
}) => (
  <ModuleTileOuter className={className} withMobileSpacer={withMobileSpacer}>
    <ModuleTileSpacer background={background} withMobileSpacer={withMobileSpacer}>
      <ModuleTileInner>{children}</ModuleTileInner>
    </ModuleTileSpacer>
  </ModuleTileOuter>
);

export default ModuleTile;
